export const mq = {
  mobile: '@media (max-width: 767px)',
  tablet: '@media (max-width: 1200px)',
  tabletUp: '@media (min-width: 900px)',
  desktop: '@media (min-width: 1024px)',
};
